
    // Check for file protocol and show warning
    if (window.location.protocol === 'file:') {
      document.getElementById('protocol-warning').style.display = 'flex';
    }
  